import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import dashboard from '@/router/routes/dashboard'
import pages from '@/router/routes/pages'
import users from '@/router/routes/users'
import jobs from '@/router/routes/jobs'
import vehicles from '@/router/routes/vehicles'
import customers from '@/router/routes/customers'
import jobTemplates from '@/router/routes/jobTemplates'
import images from '@/router/routes/images'
import questions from '@/router/routes/questions'
import vehicleChecks from "@/router/routes/vehicleChecks";
import vehicleTypes from "@/router/routes/vehicleTypes"

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...dashboard,
    ...pages,
    ...users,
    ...jobs,
    ...vehicles,
    ...customers,
    ...jobTemplates,
    ...questions,
    ...images,
    ...vehicleChecks,
    ...vehicleTypes,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ path: '/' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next({ name: 'home' })
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router